<template>
  <iframe :width="width" :height="height" :src="src" frameborder="0"></iframe>
</template>

<script>
const SpotFrame = {
  props: {
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    src: {
      type: String
    }
  }
}

export default SpotFrame
</script>



// WEBPACK FOOTER //
// src/components/SpotFrame.vue